export const wrapperStyles = 'main-container flex flex-col items-center items-center justify-center'
export const rowStyles = 'flex flex-col items-center justify-center overflow-hidden'
